var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsTesting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.000244141,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFE4DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 20.5842H49.875",
    stroke: "#F95632",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5215 20.5842H44.4798V42.9384C44.4798 45.1872 43.5865 47.3439 41.9963 48.9341C40.4062 50.5242 38.2495 51.4176 36.0007 51.4176C33.7518 51.4176 31.5951 50.5242 30.005 48.9341C28.4148 47.3439 27.5215 45.1872 27.5215 42.9384V20.5842Z",
    stroke: "#F95632",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5215 32.1467H44.4798",
    stroke: "#F95632",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsTesting);
export default __webpack_public_path__ + "static/media/DevOps_Testing.d459c3b055b6334333eeb2063f6c2e6c.svg";
export { ForwardRef as ReactComponent };